export const STRIPE_PAYMENT_FORM_MIN_HEIGHT_PX = 186;
